import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import Dialog from '../../services/Dialogs'

const ModalEnviarTramitePago = ( params : any ) => {

  const { show, handleClose, tramite } = params

  const dialog = new Dialog();

const [ envio_server, setSeEnvio ] = useState<boolean>(false)


const enviarFormulario = async (event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update(`tramite/enviar_pago/${tramite.uuid_tramite}` , { idestatus_pago : idestatus_pago })

        if(res_){
          toast.success('Los valores se actualizaron correctamente')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}

  const [ idestatus_pago, setEstatusPago ] = useState<number>(1)


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title><i className="fa fa-money"/> Enviar A Pago</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(tramite)
          }

          <small>Folio</small>
          <h5>{tramite.folio}</h5>

          <small>Pertenece a</small>
          <h5>{tramite.nombres_asesor} {tramite.paterno_asesor} {tramite.materno_asesor} </h5>


          <small>Enviar a</small>

          <div className="form-check">
            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={idestatus_pago===1} onChange={(e:any)=>{setEstatusPago(1)}} />
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Pago Anticipado
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={idestatus_pago===3} onChange={(e:any)=>{setEstatusPago(3)}} />
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              Liquidar 
            </label>
          </div>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={enviarFormulario} type="button">Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalEnviarTramitePago;